import axios from "axios";
import { getConfig } from '../configService';

export class CalendarService {
    static keycloak = null;
    static get calendarServiceBaseUrl() {
        if((window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') && getConfig().localhostApi) {
            return "http://localhost:5050/v1";
        }
        return `${getConfig().apiBaseUrl}/calendar/v1`;
    }

    static async getAvailableAppointments(userId, year, month, day, length, schedulingSlotId) {
        try {
            const slotParam = schedulingSlotId ? `&schedulingSlotId=${encodeURIComponent(schedulingSlotId)}` : '';
            const jsNow = new Date();
            const localNow = new Date(jsNow - jsNow.getTimezoneOffset() * 60000).toISOString().slice(0, -1);
            const nowParam = `&now=${encodeURIComponent(localNow)}`;
            var response = await axios(`${this.calendarServiceBaseUrl}/User/${userId}/appointments/available?year=${year}&month=${month}&day=${day}&length=${length}${slotParam}${nowParam}`);
            return await response.data;
        } catch (error) {
            console.log(error)
        }
    }

    static async getAppointments(userId, schedulingSlotId) {
        if (!CalendarService.keycloak || !CalendarService.keycloak.token) {
            throw new Error("Authorization required: Keycloak token not available");
        }
        try {
            const slotParam = schedulingSlotId ? `?schedulingSlotId=${encodeURIComponent(schedulingSlotId)}` : '';
            var response = await axios({
                method: 'get',
                url: `${this.calendarServiceBaseUrl}/User/${userId}/appointments${slotParam}`,
                headers: {
                    "Authorization": "Bearer " + CalendarService.keycloak.token
                }
            });
            return await response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    static async getWorkingHours(userId, schedulingSlotId) {
        try {
            const slotParam = schedulingSlotId ? `?schedulingSlotId=${encodeURIComponent(schedulingSlotId)}` : '';
            var response = await axios(`${this.calendarServiceBaseUrl}/User/${userId}/workinghours${slotParam}`);
            return await response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    static async setWorkingHours(userId, week, schedulingSlotId) {
        try {
            const slotParam = schedulingSlotId ? `?schedulingSlotId=${encodeURIComponent(schedulingSlotId)}` : '';
            var response = await axios({
                method: 'post',
                url: `${this.calendarServiceBaseUrl}/User/${userId}/workinghours${slotParam}`,
                headers: {
                    "Authorization": "Bearer " + CalendarService.keycloak.token
                },
                data: week
            });
            return await response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    static async makeAppointment(providerId, clientId, appTime, length, service) {
        try {
            var response = await axios({
                method: 'post',
                url: `${this.calendarServiceBaseUrl}/User/${providerId}/appointments`,
                data: {
                    service: service,
                    clientId: clientId,
                    location: {
                        latitude: 0,
                        longitude: 0,
                        address: "string",
                        city: "string",
                        state: "string",
                        zip: "string"
                    },
                    start: appTime,
                    length: length
                }
            });
            return await response.data;
        } catch (error) {
            console.log(error)
        }
    }

    static async getBlocks(userId) {
        if (!CalendarService.keycloak || !CalendarService.keycloak.token) {
            throw new Error("Authorization required: Keycloak token not available");
        }
        try {
            var response = await axios({
                method: 'get',
                url: `${this.calendarServiceBaseUrl}/User/${userId}/blocks`,
                headers: {
                    "Authorization": "Bearer " + CalendarService.keycloak.token
                }
            });
            return await response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    static async createBlock(userId, title, start, end) {
        if (!CalendarService.keycloak || !CalendarService.keycloak.token) {
            throw new Error("Authorization required: Keycloak token not available");
        }
        try {
            var response = await axios({
                method: 'post',
                url: `${this.calendarServiceBaseUrl}/User/${userId}/blocks`,
                headers: {
                    "Authorization": "Bearer " + CalendarService.keycloak.token
                },
                data: {
                    title: title,
                    start: start,
                    end: end
                }
            });
            return await response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    static async deleteBlock(userId, blockId) {
        if (!CalendarService.keycloak || !CalendarService.keycloak.token) {
            throw new Error("Authorization required: Keycloak token not available");
        }
        try {
            var response = await axios({
                method: 'delete',
                url: `${this.calendarServiceBaseUrl}/User/${userId}/blocks/${blockId}`,
                headers: {
                    "Authorization": "Bearer " + CalendarService.keycloak.token
                }
            });
            return await response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    static async getFutureAppointmentsForSlot(userId, slotId) {
        if (!CalendarService.keycloak || !CalendarService.keycloak.token) {
            throw new Error("Authorization required: Keycloak token not available");
        }
        try {
            const jsNow = new Date();
            const localNow = new Date(jsNow - jsNow.getTimezoneOffset() * 60000).toISOString().slice(0, -1);
            const fromParam = `?from=${encodeURIComponent(localNow)}`;
            var response = await axios({
                method: 'get',
                url: `${this.calendarServiceBaseUrl}/User/${userId}/slots/${slotId}/appointments/future${fromParam}`,
                headers: {
                    "Authorization": "Bearer " + CalendarService.keycloak.token
                }
            });
            return await response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    static async moveAppointmentToSlot(userId, appointmentId, newSlotId) {
        if (!CalendarService.keycloak || !CalendarService.keycloak.token) {
            throw new Error("Authorization required: Keycloak token not available");
        }
        try {
            var response = await axios({
                method: 'put',
                url: `${this.calendarServiceBaseUrl}/User/${userId}/appointments/${appointmentId}/slot?newSlotId=${encodeURIComponent(newSlotId)}`,
                headers: {
                    "Authorization": "Bearer " + CalendarService.keycloak.token
                }
            });
            return await response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    static async createManualRescheduleQueueItem(userId, item) {
        if (!CalendarService.keycloak || !CalendarService.keycloak.token) {
            throw new Error("Authorization required: Keycloak token not available");
        }
        try {
            const queueItem = {
                ...item,
                appointmentId: item.appointmentId || ""
            };
            var response = await axios({
                method: 'post',
                url: `${this.calendarServiceBaseUrl}/User/${userId}/manual-reschedule-queue`,
                data: queueItem,
                headers: {
                    "Authorization": "Bearer " + CalendarService.keycloak.token
                }
            });
            return await response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    static async rescheduleAppointment(userId, appointmentId, newSlotId, newStart) {
        if (!CalendarService.keycloak || !CalendarService.keycloak.token) {
            throw new Error("Authorization required: Keycloak token not available");
        }
        try {
            var response = await axios({
                method: 'put',
                url: `${this.calendarServiceBaseUrl}/User/${userId}/appointments/${appointmentId}/reschedule`,
                data: {
                    newSlotId,
                    newStart
                },
                headers: {
                    "Authorization": "Bearer " + CalendarService.keycloak.token
                }
            });
            return await response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    static async getManualRescheduleQueueItems(userId, slotId, includeCompleted = false) {
        if (!CalendarService.keycloak || !CalendarService.keycloak.token) {
            throw new Error("Authorization required: Keycloak token not available");
        }
        try {
            const params = new URLSearchParams();
            if (slotId) {
                params.append('slotId', slotId);
            }
            if (includeCompleted) {
                params.append('includeCompleted', 'true');
            }
            const queryString = params.toString();
            const queryParam = queryString ? `?${queryString}` : '';
            var response = await axios({
                method: 'get',
                url: `${this.calendarServiceBaseUrl}/User/${userId}/manual-reschedule-queue${queryParam}`,
                headers: {
                    "Authorization": "Bearer " + CalendarService.keycloak.token
                }
            });
            return await response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    static async getValidDestinationSlots(userId, appointmentId) {
        if (!CalendarService.keycloak || !CalendarService.keycloak.token) {
            throw new Error("Authorization required: Keycloak token not available");
        }
        try {
            var response = await axios({
                method: 'get',
                url: `${this.calendarServiceBaseUrl}/User/${userId}/appointments/${appointmentId}/valid-destination-slots`,
                headers: {
                    "Authorization": "Bearer " + CalendarService.keycloak.token
                }
            });
            return await response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    static async getClientBookings(clientId) {
        if (!CalendarService.keycloak || !CalendarService.keycloak.token) {
            throw new Error("Authorization required: Keycloak token not available");
        }
        try {
            var response = await axios({
                method: 'get',
                url: `${this.calendarServiceBaseUrl}/User/client/${clientId}/bookings`,
                headers: {
                    "Authorization": "Bearer " + CalendarService.keycloak.token
                }
            });
            return await response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}
